// extracted by mini-css-extract-plugin
module.exports = {"form_item":"a10a3f92e9--form_item--J2TdG","actions":"a10a3f92e9--actions--SIKLc","agreements":"a10a3f92e9--agreements--1uZ_I"};